module.exports = __webpack_public_path__ + "fonts/GothamSSm-Bold.ccb08b78.woff2";